import type { IdentityStorage } from './signaling/client';
import type { DeviceIdentity } from './tauri/commands';

const IDENTITY_KEY = 'viewer.identity';

/** No navegador não há cofre do Windows; a identidade fica no localStorage deste site. */
export const browserIdentity: IdentityStorage = {
  load() {
    const raw = localStorage.getItem(IDENTITY_KEY);
    return Promise.resolve(raw ? (JSON.parse(raw) as DeviceIdentity) : null);
  },
  save(identity) {
    localStorage.setItem(IDENTITY_KEY, JSON.stringify(identity));
    return Promise.resolve();
  },
};

export function browserDeviceName(userAgent = navigator.userAgent): string {
  if (userAgent.includes('OPR/')) return 'Navegador (Opera)';
  if (userAgent.includes('Edg/')) return 'Navegador (Edge)';
  if (userAgent.includes('Firefox/')) return 'Navegador (Firefox)';
  if (userAgent.includes('Chrome/')) return 'Navegador (Chrome)';
  return 'Navegador';
}
